export class Ami {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "blockDevices",
            "baseName": "blockDevices",
            "type": "Array<AmiBlockDevice>",
            "format": ""
        },
        {
            "name": "rootDeviceName",
            "baseName": "rootDeviceName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Ami.attributeTypeMap;
    }
    constructor() {
    }
}
